module.exports = "/* Small Devices, Tablets */\n@media only screen and (min-width: 480px) and (min-height: 480px) {\n  .content .intro, .content .closure {\n    display: block; } }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/work/work.breakpoints.scss
// module id = ./src/app/work/work.breakpoints.scss
// module chunks = main